










import CurrencyFormatter from '../../currencyFormatter';
export default {
    props: {
        name: String,
        initialValue: Number,
        price: Number,
        minValue: Number,
        maxValue: Number,
        canBeNegative: Boolean,
        currency: {
            default: "DKK",
            type: String
        }
    },
    computed: {
        totalValue() {
            return this.count * this.price;
        },

        renderTotalValue() {
            return CurrencyFormatter(this.currency).format(this.totalValue)                
        }
    },
    data: function() {
        return {
            count : this.initialValue,
        }
    },
    methods: {
        changed(value) {
            this.count = value.detail[0];
            
            this.$emit('priceChanged', this.totalValue);    
        }
    }
}
